import React, { FC, memo } from 'react';

import { PUBLIC_ASSETS } from '@/consts';
import StatusIcon, { CommonIconProps } from './StatusIcon';

const src = `${PUBLIC_ASSETS}/icons/inbox_mail_icon.svg`;

const ShareSuccessIcon: FC<CommonIconProps> = (props) => <StatusIcon src={src} {...props} />;

export default memo(ShareSuccessIcon);
